<motif-modal-title variant="alt">
    <h3>Key metrics for {{data.name}}</h3>
    <button motifIconButton aria-label="Close modal" [motif-modal-close]="true">
    <motif-icon [src]="'/assets/icons/navigation/ic_close_24px.svg'"></motif-icon>    </button>
</motif-modal-title>
<motif-modal-content>
<!----- START OF KEY METRICS SECTION ------>
<section class="key-metrics">
    <div class="key-metrics-content">
      <ng-container *ngIf="!showMetricLoader else chartLoaderBlock">
        <div class="carousel-container">
          <owl-carousel-o #owlRef [options]="carouselOptions"
                          (dragging)="onCarouselSlideDragging($event)">
            <ng-container *ngFor="let metric of metrics">
              <ng-template carouselSlide>
                <div class="slide-item" [ngClass]="{ selected: metric.label === selectedMetric?.label }"
                     (click)="!isCarouselSlideDragging && onCarouselSlideItemClick(metric)">
                  <h3>{{ metric.label }} </h3>
                </div>
              </ng-template>
            </ng-container>
          </owl-carousel-o>
          <div class="action-container">
            <div class="prev" (click)="owlRef.prev()"></div>
            <div class="next" (click)="owlRef.next()"></div>
          </div>
        </div>
        <div class="chart-container">
          <ng-container *ngIf="!showMetricChartLoader else chartLoaderBlock">
            <app-line-projection-chart *ngIf="selectedMetric.label !== 'Revenue&Margin'"
                                       [chartData]="chartData" [lineLabelName]="$any(selectedMetric?.label)">
            </app-line-projection-chart>
            <app-revenue-margin-chart *ngIf="selectedMetric.label === 'Revenue&Margin'"
                                      [chartData]="chartData">
            </app-revenue-margin-chart>
          </ng-container>
          
        </div>
      </ng-container>
      
    </div>
  </section>
  <ng-template #chartLoaderBlock>
    <div class="chart-loader">
      <app-loader></app-loader>
    </div>
  </ng-template>
  <!----- END OF KEY METRICS SECTION ------>
  
</motif-modal-content>